<div class="menu-heading manageclientbar">Admin Settings</div>
<ul class="admin__nav">
    <li><a routerLink="/admin/admin-client-user">Manage Client Users</a></li>
    <li><a routerLink="/admin/user">Manage KPMG Users</a></li>
    <li *ngIf="isChampionUser"><a routerLink="/admin/master-activities">Manage Master Activities</a></li>
    <li><a (click)="onGoToRcsWatson()">Manage Credit Report Templates</a></li>
    <li><a routerLink="/admin/action-logs">Action Logs</a></li>
    <!-- <li ><a (click)="onGoToRcsWatson()">RCS w/Watson</a></li>        
    <li ><a (click)="onGoToRcsContract()">RCS Contract Analysis</a></li>         -->
    <!-- <li><i class="fas fa-sliders-v"></i>&nbsp;&nbsp;<a routerLink="/admin/my-preferences">My Preferences</a></li>            -->
</ul>